<div class="ya-typography" (swiperight)="swiperNavigateBack()">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="title-container title-margin">
      <ng-container *ngIf="groupManageData">
        <h2><span class="title-text-size">{{GetGroupNameText(groupManageData.groupName)}}</span></h2>
        <h2><span class="title-text-size">{{GetGroupCreatorText(groupManageData.creatorName)}}</span></h2>
      </ng-container>
    </div>
    <div class="group-info-content">
      <!-- Group manage data-->
      <div class="group-info-wrap">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-remote-group.svg">
          </div>
        </div>
        <div class="title-container description-margin">
          <ng-container *ngIf="groupManageData">
            <ng-container *ngIf="isGroupDelivery then DeliveryTemplate else PickUpTemplate"></ng-container>
            <ng-template #DeliveryTemplate>
              <div class="info-content">
                <span class="info-label" [innerHTML]="setGroupOrderEndTime(groupManageData.selectedOrderTime)"></span>
                <span class="info-label" [innerHTML]="setDeliveryEndTime(groupManageData.selectedServiceTime)"></span>
                <span class="info-label"
                  [innerHTML]="setDeliveryGroupAddress(groupManageData.groupDeliveryAddress)"></span>
                <ng-container *ngIf="locationData$|async; let location">
                  <span class="info-label" [innerHTML]="setDeliveryLocationName(location.name)"></span>
                </ng-container>
              </div>
            </ng-template>
            <ng-template #PickUpTemplate>
              <div class="info-content">
                <span class="info-label" [innerHTML]="setGroupOrderEndTime(groupManageData.selectedOrderTime)"></span>
                <span class="info-label" [innerHTML]="setPickupEndTime(groupManageData.selectedServiceTime)"></span>
                <div class="info-address">
                  <span class="info-label" langkey="phRemoteOrder_Group_Pickup_Address"></span>
                  <ng-container *ngIf="locationData$|async; let location">
                    <span class="info-label font-weight--medium space-left">{{location.street}}, {{location.zipCode + "
                      "
                      +location.city}}</span>
                  </ng-container>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <div class="group-info-wrap">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-gruppenwarenkorb.svg"></div>
        </div>
        <div class="title-container description-margin">
          <p>
            <span langkey="phGroupOrder_Landingpage_BasketTitle"></span>:
          </p>
          <ng-container
            *ngIf="group_basket_count$ |async; let group_basket_count; then filledBasketTemplate else emptyBasketTemplate"></ng-container>
          <ng-template #filledBasketTemplate>
            <p>
              <ng-container *ngIf="group_basket_count$ |async; let group_basket_count">
                <span class="count">{{group_basket_count}}</span>
              </ng-container>
              <span class="middle-text" langkey="phRemoteOrder_Group_Servicepage_BasketContent"></span>
              <ng-container *ngIf="group_basket_price$ |async; let group_basket_price">
                <span class="price">{{formatCurrency(group_basket_price)}}</span>
              </ng-container>
            </p>
          </ng-template>
          <ng-template #emptyBasketTemplate>
            <p>
              <span langkey="phRemoteOrder_Group_Servicepage_EmptyBasketContent"></span>
            </p>
          </ng-template>
          <!--State "Ready"-->
          <div class="selection-state">
            <span langkey="phRemoteOrder_Group_Set_State_Ready"></span>
            <mat-checkbox class="checkItems custom-ripple" [checked]="(stateReady$|async)"
              (change)="changeStateReady(userId,$event)">
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="groupOrder-service-item-container">
      <!--Order -->
      <div class="ya-icon-button service-button animate" (click)="navigateToMenuGroup()">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-bestellen.svg"></div>
        </div>
        <div class="content-container">
          <h2 class="title" langkey="phRemoteOrder_Group_Servicepage_Order"></h2>
          <span class="text content-container--subfont"
            langkey="phRemoteOrder_Group_Servicepage_Order_description"></span>
        </div>
      </div>
      <!-- Group overview-->
      <div class="ya-icon-button service-button animate" (click)="navigateToGroupOverview()">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
        </div>
        <div class="content-container">
          <h2 class="title" langkey="phRemoteOrder_Group_Servicepage_ViewGroup"></h2>
          <span class="text content-container--subfont"
            langkey="phRemoteOrder_Group_Servicepage_ViewGroup_description"></span>
        </div>
      </div>
      <!--Payment-->
      <ng-container *ngIf="isGroupCreator">
        <div class="ya-icon-button service-button animate" (click)="navigateToPayment()"
          [ngClass]="(group_basket_count$ |async) ? '' : 'disable'">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="hypersoft-bezahlen.svg"></div>
          </div>
          <div class="content-container">
            <h2 class="title" langkey="phRemoteOrder_Group_Servicepage_Pay">
            </h2>
            <span class="text content-container--subfont"
              langkey="phRemoteOrder_Group_Servicepage_Pay_description"></span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="ya-webshop-button-container animate" (click)="leaveGroup()">
      <button mat-flat-button>
        <span langkey="phGroupOrder_Landingpage_LeaveGroupOrder_Btn"></span>
      </button>
    </div>
  </div>
</div>